<template>
  <div class="py-4 space-y-6">
    <!-- Title -->
    <div class="text-center mb-6">
      <h1 class="text-xl font-bold text-foreground mb-2">
        {{ $t('report.clients_revenue_by_card_info.title') }}
      </h1>
      <p class="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
        {{ $t('report.clients_revenue_by_card_info.description') }}
      </p>
    </div>

    <!-- Segments -->
    <div class="space-y-4">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.clients_revenue_by_card_info.how_to_read') }}
        </h2>
      </div>

      <div class="space-y-3">
        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #06C8FF"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.clients_revenue_by_card_info.card_types_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.clients_revenue_by_card_info.card_types_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #C4CAD4"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.clients_revenue_by_card_info.non_member_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.clients_revenue_by_card_info.non_member_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-sm shrink-0 mt-1" style="background: rgba(107,114,128,0.2)"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.clients_revenue_by_card_info.colors_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.clients_revenue_by_card_info.colors_desc') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Views -->
    <div class="space-y-2.5">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.clients_revenue_by_card_info.views_section') }}
        </h2>
      </div>

      <div class="info-metric-item">
        <span class="info-metric-label">{{ $t('report.clients_revenue_by_card_info.evolution_label') }}</span>
        <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
          {{ $t('report.clients_revenue_by_card_info.evolution_desc') }}
        </p>
      </div>
      <div class="info-metric-item">
        <span class="info-metric-label">{{ $t('report.clients_revenue_by_card_info.distribution_label') }}</span>
        <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
          {{ $t('report.clients_revenue_by_card_info.distribution_desc') }}
        </p>
      </div>
    </div>

    <!-- Controls -->
    <div class="space-y-2.5">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.clients_revenue_by_card_info.controls_section') }}
        </h2>
      </div>

      <div class="info-metric-item">
        <span class="info-metric-label">{{ $t('report.clients_revenue_by_card_info.mode_label') }}</span>
        <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
          {{ $t('report.clients_revenue_by_card_info.mode_desc') }}
        </p>
      </div>
      <div class="info-metric-item">
        <span class="info-metric-label">{{ $t('report.clients_revenue_by_card_info.aggregation_label') }}</span>
        <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
          {{ $t('report.clients_revenue_by_card_info.aggregation_desc') }}
        </p>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
// Content-only component — no props needed.
// Injected into a BottomSheet from CenterClientsReport.
</script>

<style scoped>
.info-metric-item {
  padding-left: 0.75rem;
  border-left: 2px solid rgba(107, 114, 128, 0.15);
}
:is(.dark *).info-metric-item {
  border-left-color: rgba(255, 255, 255, 0.1);
}
.info-metric-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--foreground);
}
</style>
